import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { SortParams } from 'shared/models/common';
import { CaseStatuses } from 'utils/enums';

import type { SpaceRenovationRequestsState } from './types';

const initialState: SpaceRenovationRequestsState = {
  searchTerm: '',
  sortParams: {
    order: 'desc',
    orderBy: 'CreatedOn',
    type: 'date',
  },
  status: 'all',
};

const userSpaceRenovationRequestsSlice = createSlice({
  name: 'userSpaceRenovationRequests',
  initialState,
  reducers: {
    setSearchTerm: (state, action: PayloadAction<string>) => {
      state.searchTerm = action.payload;
    },
    setSortParams: (state, action: PayloadAction<SortParams>) => {
      state.sortParams = action.payload;
    },
    setStatus: (state, action: PayloadAction<string | CaseStatuses>) => {
      state.status = action.payload;
    },
  },
});

export const { setSearchTerm, setSortParams, setStatus } =
  userSpaceRenovationRequestsSlice.actions;
export default userSpaceRenovationRequestsSlice.reducer;
